import React from 'react';
import { connect } from 'react-redux';
import { getFormValues, change as onChange } from 'redux-form';
import {
  translate as t,
} from 'admin-on-rest';
import {
  List,
  FlatButton,
} from 'material-ui';
import CreateIcon from 'material-ui/svg-icons/content/add';
import CheckpointForm from './CheckpointForm';

class CheckpointListBuilder extends React.Component {
  defaultCheckpoint = () => {
    const randomInteger = Math.floor(Math.random() * 1000);
    const now = new Date().getTime();
    return {
      id: `${now}${randomInteger}`,
      randomOrder: true,
      minCorrectAnswers: 0,
    };
  }

  createCheckpoint = () => {
    const checkpoint = this.defaultCheckpoint();
    const prevCheckpoints = this.props.quiz.checkpoints || [];
    this.callChangeState([...prevCheckpoints, checkpoint]);
  }

  updateCheckpoint = (delta, id) => {
    const prevCheckpoints = this.props.quiz.checkpoints || [];
    const nextCheckpoints = prevCheckpoints.map((checkpoint) => {
      if (checkpoint.id === id) {
        return { ...checkpoint, ...delta };
      }
      return checkpoint;
    });
    this.callChangeState(nextCheckpoints);
  }

  deleteCheckpoint = (id) => {
    const prevCheckpoints = this.props.quiz.checkpoints || [];
    const nextCheckpoints = prevCheckpoints.filter((c) => c.id !== id);
    this.callChangeState(nextCheckpoints);
  }

  callChangeState = (listOfCheckpoints) => {
    this.props.change('record-form', 'checkpoints', listOfCheckpoints);
  }

  render() {
    const checkpoints = (this.props.quiz.checkpoints || []).map((c, idx) => (
      <CheckpointForm
        {...c}
        key={c.id}
        path={`checkpoints.${idx}`}
        headerTitle={`${idx + 1}. ${c.title || ''}`}
        onChange={this.updateCheckpoint}
        onRemove={this.deleteCheckpoint}
      />
    ));
    return (
      <>
        <h3>Checkpoints</h3>
        <FlatButton
          label={this.props.translate('create.item', {
            item: this.props.translate('resources.quizes.fields.checkpoint'),
          })}
          onClick={this.createCheckpoint}
          icon={<CreateIcon />}
        />
        <List>
          {checkpoints}
        </List>
    </>
    );
  }
}

const selector = getFormValues('record-form');

export default connect(
  (state) => ({
    quiz: selector(state),
  }),
  { change: onChange }
)(t(CheckpointListBuilder));
